import React, { useCallback, useEffect, useMemo, useState } from "react";
import { FaDownload, FaSpinner } from "react-icons/fa";
import Popup from "reactjs-popup";
import { DashboardLoading } from "../../../../CommonComponents/Loader";
import EmptyDataAlert from "../../../../CommonComponents/EmptyDataAlert";
import DataTable from "../../../../CommonComponents/DataTable";
import Pagination from "../../../../CommonComponents/Pagination";
import { getNewUsersList } from "../../../../../Services/Dashboard";
import * as XLSX from "xlsx";

const NewUsers = ({ isOpen, onClose }) => {
  const [userData, setUsersData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [showLoanDetails, setShowLoanDetails] = useState(false);
  const [isExportLoading, setExportLoading] = useState();
  const [selectedFilter, setSelectedFilter] = useState("user");
  const [filterValue, setFilterValue] = useState([]);
  const [error, setError] = useState(false);
  const [isExport, setIsExport] = useState(true);
  const [pagination, setPagination] = useState({
    totalDocs: 0,
    totalPages: 1,
    page: 0,
    limit: 10,
    hasNextPage: false,
    hasPrevPage: false,
  });

  const columns = useMemo(
    () => [
      {
        Header: "Borrower Name",
        accessor: "",
        Cell: ({ row }) => (
          <div className="my-1 px-2">
            <p>
              {row?.original?.name || ""} {row?.original?.first_name || ""}{" "}
              {row?.original?.middle_name || ""}{" "}
              {row?.original?.last_name || ""}
            </p>
          </div>
        ),
      },
      {
        Header: "UCID",
        accessor: "system_id",
      },
      {
        Header: "Contact no.",
        accessor: "phone_number",
      },
      {
        Header: "Email",
        accessor: "email",
      },
    ],
    []
  );

  const data = React.useMemo(() => filterValue);

  const fetchData = useCallback(async (page = 1, query = searchQuery) => {
    setLoading(true);
    try {
      const data = await getNewUsersList(
        !isExport,
        page,
        query,
        selectedFilter
      );
      console.log("Data is here: ", data);
      setUsersData(data);
      setLoading(false);
    } catch (error) {
      setSearchQuery("");
      setLoading(false);
    }
  });

  const handleOptionChange = () => {
    if (userData) {
      const filteredData =
        selectedFilter === "user"
          ? userData?.users?.docs || []
          : userData?.organizations?.docs || [];

      console.log("Filter value == ", filteredData);

      setFilterValue(filteredData);
      setPagination({
        totalDocs:
          selectedFilter === "user"
            ? userData?.users?.totalDocs
            : userData?.organizations?.totalDocs,
        totalPages:
          selectedFilter === "user"
            ? userData?.users?.totalPages
            : userData?.organizations?.totalPages,
        page:
          selectedFilter === "user"
            ? userData?.users?.page
            : userData?.organizations?.page,
        limit:
          selectedFilter === "user"
            ? userData?.users?.limit
            : userData?.organizations?.limit,
        hasNextPage:
          selectedFilter === "user"
            ? userData?.users?.hasNextPage
            : userData?.organizations?.hasNextPage,
        hasPrevPage:
          selectedFilter === "user"
            ? userData?.users?.hasPrevPage
            : userData?.organizations?.hasPrevPage,
      });
    }
  };

  useEffect(() => {
    handleOptionChange();
  }, [userData, selectedFilter]);

  useEffect(() => {
    fetchData();
  }, []);

  const exportToExcel = async () => {
    setExportLoading(true);
    const data = await getNewUsersList(isExport, "", "", "");
    setExportLoading(false);
    const userDocs = data?.users?.docs || [];
    const orgDocs = data?.organizations?.docs || [];
    const formatedData = [
      ...userDocs?.map((user) => ({
        Name: `${user.first_name || ""} ${user.middle_name || ""} ${
          user.last_name || ""
        }`.trim(),
        SystemID: user.system_id,
        Email: user.email,
        Phone: user.phone_number,
        Role: user.role,
      })),
      ...orgDocs?.map((org) => ({
        Name: org.name,
        SystemID: org.system_id,
        Email: org.email,
        Phone: org.phone_number,
        Role: org.role,
      })),
    ];
    const ws = XLSX.utils.json_to_sheet(formatedData);
    const columnWidths = [
      { wch: 30 },
      { wch: 20 },
      { wch: 30 },
      { wch: 15 },
      { wch: 10 },
    ];
    ws["!cols"] = columnWidths;
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "New Users");
    XLSX.writeFile(wb, "New_Users.xlsx");
  };

  const handleSearch = async () => {
    setLoading(true);
    fetchData(1, searchQuery);
  };

  const nextPage = useCallback(() => {
    if (pagination.hasNextPage) fetchData(pagination.page + 1, searchQuery);
  }, [fetchData, searchQuery, pagination]);

  const previousPage = useCallback(() => {
    if (pagination.hasPrevPage) fetchData(pagination.page - 1, searchQuery);
  }, [fetchData, searchQuery, pagination]);

  return (
    <>
      <Popup
        open={isOpen}
        modal
        closeOnDocumentClick={false}
        className="custom-popup"
      >
        <div className="popup-style popup-content">
          <div className="bg-bgclr4 md:w-[950px] w-[400px]  mx-auto h-[520px] rounded-[14px]">
            <div className="flex justify-between font-avenir text-bgclr px-10 pt-5">
              <h1 className="text-[20px] font-[600] ">New Users in Last Month</h1>
              <div className="flex gap-4">
                <button
                  type="submit"
                  onClick={() => {
                    exportToExcel();
                  }}
                  disabled={loading || isExportLoading}
                  className="flex gap-2 items-center py-1 px-7  bg-bgclr rounded-md text-txtclr"
                >
                  {isExportLoading ? (
                    <FaSpinner size={18} className="animate-spin text-txtclr" />
                  ) : (
                    <FaDownload size={18} />
                  )}{" "}
                  Download Report
                </button>
                <button
                  type="submit"
                  onClick={() => {
                    onClose();
                  }}
                  disabled={loading}
                  className="font-bold py-1 px-3 rounded-md bg-red-700 text-txtclr"
                >
                  X
                </button>
              </div>
            </div>
            <div>
              {!showLoanDetails ? (
                <div>
                  <div className="searchBar-style-dashboard">
                    <select
                      value={selectedFilter}
                      onChange={(e) => {
                        setSelectedFilter(e.target.value);
                      }}
                      className="border border-[#EBEBEB] text-gray-400 rounded-md lg:pl-2 lg:pr-5 py-3 lg:mr-2"
                    >
                      <option value="user">Individual</option>
                      <option value="entity">Organization</option>
                    </select>
                    <input
                      type="search"
                      placeholder="Search by name, CUID, email, phone no."
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      className="searchBar-input-dashboard"
                    />
                    <button
                      onClick={() => handleSearch()}
                      className="searchBar-btn-dashboard"
                    >
                      Search
                    </button>
                  </div>
                  {loading ? (
                    <div className="flex justify-center h-[360px] items-center">
                      <DashboardLoading />
                    </div>
                  ) : (
                    <>
                      {filterValue?.length === 0 ? (
                        <div className="h-screen">
                          <EmptyDataAlert
                            title={
                              error
                                ? "No Loans Found"
                                : "Search Loan by Loan number"
                            }
                          />
                        </div>
                      ) : (
                        <div className="mt-2">
                          <div>
                            <div className="pt-3 w-[900px] mx-auto overflow-x-auto h-[335px] overflow-y-auto ">
                              <DataTable columns={columns} data={data} />
                            </div>
                            <Pagination
                              goToPrevPage={previousPage}
                              goToNextPage={nextPage}
                              hasPrevPage={pagination.hasPrevPage}
                              hasNextPage={pagination.hasNextPage}
                              pagination={{
                                page: pagination.page,
                                totalPages: pagination.totalPages,
                              }}
                            />
                          </div>
                        </div>
                      )}
                    </>
                  )}
                </div>
              ) : (
                <div></div>
              )}
            </div>
          </div>
        </div>
      </Popup>
    </>
  );
};

export default NewUsers;
